import { Badge } from "@/components/ui/badge";

export function ProvenanceBadge({ inline = false }) {
  if (inline) {
    return <span className="inline-block w-1.5 h-1.5 rounded-full mr-1.5" style={{ backgroundColor: "#FF6B00" }} data-testid="provenance-dot" />;
  }
  return (
    <Badge
      className="border-[#FF6B00]/40 text-[#FF6B00] bg-[#FF6B00]/10 text-[9px] font-heading uppercase tracking-wide rounded-full"
      data-testid="provenance-badge"
    >
      Simulated Demo Data
    </Badge>
  );
}
